var map = {
	"./aardrijkskunde.mp4": 802,
	"./architectuur.mp4": 434,
	"./biografie.mp4": 82,
	"./biologie.mp4": 125,
	"./ckv.mp4": 139,
	"./duits.mp4": 317,
	"./economie.mp4": 979,
	"./engels.mp4": 568,
	"./frans.mp4": 667,
	"./geschiedenis.mp4": 233,
	"./handvaardigheid.mp4": 396,
	"./kunstgeschiedenis.mp4": 211,
	"./lichamelijke-opvoeding.mp4": 975,
	"./maatschappijleer.mp4": 857,
	"./muziek.mp4": 646,
	"./natuurkunde.mp4": 627,
	"./nederlands.mp4": 423,
	"./onbekend.mp4": 288,
	"./scheikunde.mp4": 827,
	"./sterrenkunde.mp4": 421,
	"./tekenen.mp4": 222,
	"./textiele-werkvormen.mp4": 134,
	"./toneel-drama.mp4": 988,
	"./wiskunde.mp4": 445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;